var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5174 9.01523C16.143 9.01523 15.0249 10.1334 15.0249 11.5078C15.0249 12.8819 16.143 14 17.5174 14C18.892 14 20.0099 12.8819 20.0099 11.5078C20.0099 10.1334 18.8918 9.01523 17.5174 9.01523ZM17.5174 12.6021C16.9136 12.6021 16.4226 12.1111 16.4226 11.5075C16.4226 10.9037 16.9136 10.4127 17.5174 10.4127C18.1212 10.4127 18.6122 10.904 18.6122 11.5075C18.6123 12.111 18.1212 12.6021 17.5174 12.6021Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.93 0H0.698827C0.312856 0 0 0.312856 0 0.69887V11.4609C0 11.8468 0.312856 12.1597 0.698827 12.1597H2.88852V10.762H1.39765V1.3977H13.2312V11.4609H14.6289V0.69887C14.6289 0.312856 14.3161 0 13.93 0Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7237 10.762H6.31274V12.1597H15.7237V10.762Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58896 9.01523C3.21458 9.01523 2.09644 10.1334 2.09644 11.5078C2.09644 12.8819 3.21458 14 4.58896 14C5.96334 14 7.08148 12.8819 7.08148 11.5078C7.08144 10.1334 5.96334 9.01523 4.58896 9.01523ZM4.58896 12.6021C3.98516 12.6021 3.49413 12.1111 3.49413 11.5075C3.49413 10.9037 3.98516 10.4127 4.58896 10.4127C5.19275 10.4127 5.68378 10.904 5.68378 11.5075C5.68378 12.111 5.1925 12.6021 4.58896 12.6021Z",
    fill: "#383838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.965 5.80035H13.9301V7.19801H20.2661V10.762H19.2645V12.1597H20.965C21.3509 12.1597 21.6638 11.8471 21.6638 11.4609V6.49918C21.6638 6.11321 21.351 5.80035 20.965 5.80035Z",
    fill: "#383838"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.852 2.90106C18.7292 2.6779 18.4944 2.53908 18.2395 2.53908H13.9301V3.93673H17.8263L19.4208 6.83596L20.6456 6.16227L18.852 2.90106Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.ee0e5b4f6f82e5790ce06c2ba5285e31.svg";
export { ForwardRef as ReactComponent };